<template>
  <!--<div class="regLogin">
    <img src="@/assets/img/regLogin/background.jpg" alt="" style="height: 100vh;width: 100%;">
    &lt;!&ndash;el card&ndash;&gt;

    <div class="login">
      <span class="title" >{{$t('regLogin.实验室协同平台')}}</span>
      <el-card class="box-card">
        <div class="notice">
          <svg class="icon" aria-hidden="true" style="font-size:14px;">
            <use xlink:href="#icon-color-notice"></use>
          </svg>
          <span >&nbsp{{$t('regLogin.通知')}}</span>
        </div>
        <el-form ref="formRef" :model="datas" status-icon :rules="rules" label-width="90px"
                 @keyup.enter.native="log" class="demo-ruleForm" >
          <el-form-item :label="$t('regLogin.用户名')" prop="username">
            <el-input v-model="datas.username" autocomplete="off" />
          </el-form-item>
          <el-form-item :label="$t('regLogin.密码')" prop="password">
            <el-input v-model="datas.password" autocomplete="off" type="password"/>
          </el-form-item>
          <el-form-item v-if="radio == '2'" :label="$t('regLogin.确认密码')" prop="repassword">
            <el-input v-model="datas.repassword" autocomplete="off" type="password"/>
          </el-form-item>
          <div class="radio">
            <el-radio v-model="radio" label="1" size="small" @click="radioClick">{{$t('regLogin.登录')}}</el-radio>
            <el-radio v-model="radio" label="2" size="small" @click="radioClick">{{$t('regLogin.注册')}}</el-radio>
          </div>
          <el-tooltip class="box-item" effect="light" :content="$t('regLogin.请联系管理员修改')" placement="top-end">
            <span class="forget" v-if="radio === '1'">{{$t('regLogin.忘记密码')}}</span>
          </el-tooltip>
          <div class="button">
            <el-button v-if="radio === '2'" type="primary" @click="reg">{{$t('regLogin.注册')}}</el-button>
            <el-button v-else="radio == '2'" type="primary" @click="log">{{$t('regLogin.登录')}}</el-button>
            <el-button @click="resetForm">{{$t('regLogin.重置')}}</el-button>
          </div>
        </el-form>

      </el-card>
    </div>
  </div>-->

  <div class="regLogin">
    <!--<Animate ref="animate" />-->

    <img src="@/assets/img/regLogin/background.jpg" alt="" style="height: 100vh;width: 100%;">
    <!--el card-->
    <!--中文-->
    <div class="loginZh" v-show="showLang === 'zh'">
      <span class="title">实验室协同平台</span>
      <el-card class="box-card">
        <div class="notice">
          <svg class="icon" aria-hidden="true" style="font-size:14px;">
            <use xlink:href="#icon-color-notice"></use>
          </svg>
          <span>&nbsp通知:仅支持学校内部人员注册,并开放全部功能</span>
        </div> <!--ref="formRef"-->
        <el-form ref="formRef" :model="datas" status-icon :rules="rules" label-width="90px"
                 @keyup.enter.native="log" class="demo-ruleForm">
          <el-form-item label="职工/学号" prop="username" label-width="85px">
            <el-input v-model="datas.username" autocomplete="off"/>
          </el-form-item>
          <el-form-item label="密码" prop="password" label-width="85px">
            <el-input v-model="datas.password" autocomplete="off" type="password"/>
          </el-form-item>
          <el-form-item v-if="zhReg" label="确认密码" prop="repassword" label-width="85px">
            <el-input v-model="datas.repassword" autocomplete="off" type="password"/>
          </el-form-item>
          <div class="radio" v-if="zhReg">
            <el-radio v-model="radio" label="0" size="small" >教职工</el-radio>
            <el-radio v-model="radio" label="1" size="small" >学生</el-radio>
          </div>
          <el-tooltip class="box-item" effect="light" content="请联系管理员修改" placement="top-end">
            <span class="forget" v-if="!zhReg">忘记密码?</span>
          </el-tooltip>
          <span class="regNow" @click="toReg" v-if="!zhReg">立即注册</span>
          <span class="loginNow" @click="toLogin" v-if="zhReg">去登陆</span>
          <div class="button">
            <el-button v-if="zhReg" type="primary" @click="reg">注册</el-button>
            <el-button v-else="zhReg" type="primary" @click="log">登录</el-button>
            <el-button @click="resetForm">重置</el-button>
          </div>
        </el-form>

      </el-card>
    </div>

    <!--英文-->
    <div class="loginEn" v-show="showLang === 'en'">
      <span class="title">Laboratory collaboration platform</span>
      <el-card class="box-card">
        <div class="notice">
          <svg class="icon" aria-hidden="true" style="font-size:14px;">
            <use xlink:href="#icon-color-notice"></use>
          </svg>
          <span>&nbspNotice: it only supports the registration of internal personnel of the school and opens all functions</span>
        </div>
        <el-form ref="formRef" :model="datas" status-icon :rules="rules" label-width="90px" @keyup.enter.native="log" class="demo-ruleForm">
          <el-form-item label="Employee/student number" prop="username" label-width="202px">
            <el-input v-model="datas.username" autocomplete="off"/>
          </el-form-item>
          <el-form-item label="Password" prop="password" label-width="200px">
            <el-input v-model="datas.password" autocomplete="off" type="password"/>
          </el-form-item>
          <el-form-item v-if="enReg" label="Confirm password" prop="repassword" label-width="200px">
            <el-input v-model="datas.repassword" autocomplete="off" type="password"/>
          </el-form-item>
          <div class="radio" v-if="enReg">
            <el-radio v-model="radio" label="0" size="small" >Teacher</el-radio>
            <el-radio v-model="radio" label="1" size="small" >Student</el-radio>
          </div>
          <el-tooltip class="box-item" effect="light" content="Please contact the administrator to modify" placement="top-end">
            <span class="forget" v-if="!enReg">Forget password?</span>
          </el-tooltip>
          <span class="regNow" @click="toEnReg" v-if="!enReg">Register now</span>
          <span class="loginNow" @click="toEnLogin" v-if="enReg">Go login</span>
          <div class="button">
            <el-button v-if="enReg" type="primary" @click="reg">Register</el-button>
            <el-button v-else="enReg" type="primary" @click="log">Login</el-button>
            <el-button @click="resetForm">Reset</el-button>
          </div>
        </el-form>

      </el-card>
    </div>
  </div>

</template>

<script>
  import Animate from "@/components/common/Animate";

  import {ElMessage, ElMessageBox} from 'element-plus/lib/components'
  import {reactive, ref, onMounted, getCurrentInstance,} from "vue";
  import {useRoute, useRouter} from 'vue-router';
  import {useStore, mapGetters} from 'vuex'
  import bus from 'vue3-eventbus'
  import { useI18n } from 'vue-i18n'//要在js中使用国际化

  import { setCookie, getCookie, md5 } from "@/common/utils";
  import {register, login, queryUsername, queryJno, checkPassword} from '@/network/regLogin'
  import { insertRegister, insertUser, queryRegister, totalRegister, deleteRegister } from "@/network/register";

  import '@/assets/css/font/iconfont.css'
  import '@/assets/css/font/iconfont.js'

  export default {
    name: "login",
    components:{
      Animate
    },
    computed: {
      ...mapGetters(['showLang'])
    },//computed
    setup() {

      //data
      // t 引用i18n
      const { t } = useI18n()
      let instance = reactive({});
      instance = getCurrentInstance();
      const router = useRouter()
      const { proxy } = getCurrentInstance();
      const store = useStore();
      // 验证规则
      let checkRepassword = (rule, value, callback) => {
        /*
        * 密码验证规则
        * 之所以弹出两次ElMessage,blur一次,点击注册一次
        * */


        if (datas.password === datas.repassword) {

          return callback();
        } else {
          callback(new Error('两次密码不一致'));
          //instance.proxy.$message.error('密码不一致')  $message的全局引用
          ElMessage.error('密码不一致');
        }
      };
      // 数据表单
      let datas = reactive({
        //属性写不写都行
      });
      // 验证规则
      let rules = reactive({
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur',}
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur',}
        ],
        repassword: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur'},
          {validator: checkRepassword, trigger: 'blur'},
        ],
      });
      // 教师学生单选框
      const radio = ref('0');
      // formRef
      const formRef = ref(null)


      onMounted(() => {
        /*let timer = setTimeout(function () {
          instance.ctx.$refs.animate.isShow = false
          clearTimeout(timer)
        }, 100)*/
      })


      // 中文对应的数据
      // 控制中文注册/登录的属性
      let zhReg = ref(false)
      // 切换注册登录
      function toReg() {
        zhReg.value = true
        document.querySelector('.el-card').style.height = zhReg ? '265px' : '215px';
      }
      // 切换注册登录
      function toLogin() {
        zhReg.value = false
        document.querySelector('.el-card').style.height = zhReg ? '193px' : '265px';
      }

      // 英文对应的数据
      // 控制中文注册/登录的属性
      let enReg = ref(false)
      // 切换注册登录
      function toEnReg() {
        enReg.value = true
        document.querySelector('.el-card').style.height = enReg ? '280px' : '215px';
      }
      // 切换注册登录
      function toEnLogin() {
        enReg.value = false
        document.querySelector('.el-card').style.height = enReg ? '215px' : '280px';
      }




      //methods
      window.onload = async function () {
        await queryJno(localStorage.getItem('username')).then(result => {
          if (result.state === 200)
            store.commit('changePower', result.data)
        })
      };
      // 清空输入框
      function resetForm() {
        instance.proxy.$refs.formRef.resetFields();
      }
      // 返回剩余注册次数 每天最多注册三次
      function modifyTimes() {
        let times = getCookie('fre')
        if (times === null){
          setCookie('fre', 6125625, 1)  //((3 + 33) * 66) + 99
          times = 6125625
        }
        // 剩余注册次数
        let remain = 0
        let val = ((Math.sqrt(times) - 99) / 66) - 33;
        if (val === 1 || val === 2 || val === 3){
          remain = val
          val = val -1;
          setCookie('fre', (((val + 33) * 66) + 99) * (((val + 33) * 66) + 99), 1)
        }
        return remain;
      }
      //注册
      function reg() {
        /*validate验证整个表单。接收回调或返回 valid()=>{}匿名函数作为validate()函数的回调实参，当表单验证通过后valid为true; */
        instance.proxy.$refs.formRef.validate((valid) => {
          if (valid) {
            let remain = modifyTimes();
            if (remain !== 0 || store.state.powerNo === 1){
              insertRegister(datas.username, datas.password, parseInt(radio.value)).then(res => {
                localStorage.removeItem('token');
                //localStorage.removeItem('username')

                if (res.state === 200) {
                  ElMessageBox.alert(
                      t('messages.注册请求已提交至后台,等待管理员审核,请24小时后登陆!'),
                      'Tips',
                      { confirmButtonText: t('messages.确认'),}
                  )
                } else ElMessage.error(res.message);
              })
            } else ElMessage.error(t('regLogin.您的注册次数已用完'));
          }
        })
      }

      // 登录
      function log() {
        /*validate验证整个表单。接收回调或返回 valid()=>{}匿名函数作为validate()函数的回调实参，当表单验证通过后valid为true; */
        instance.proxy.$refs.formRef.validate((valid) => {
          if (valid) {
            login(datas.username, datas.password).then(result => {
              localStorage.removeItem('token');
              localStorage.removeItem('username')
              store.commit('changeToken', '')
              if (result.state === 200) {
                localStorage.setItem('token', result.data);
                localStorage.setItem('username', datas.username)
                ElMessage.success(t('regLogin.登录成功'));
                router.replace('/')
                store.commit('changeToken', result.data)
              } else ElMessage.error(result.message);
            })
          }
        })
      }

      //i18n事件总线
      //bus.on('changeLang', type => proxy.$i18n.locale = type);


      return {
        datas, rules, radio, zhReg, enReg, formRef,
        resetForm, reg, log, toReg, toLogin, toEnReg, toEnLogin,
      }

    },//setup

  }
</script>

<style scoped lang="less">
  .icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }

  .regLogin {
    //中文版样式
    .loginZh {
      position: fixed;
      z-index: 9;
      top: 30%;
      right: 10%;
      width: 380px;
      height: 285px;

      .title {
        font-size: 28px;
        letter-spacing: 8px;
        color: #ffffff;
        display: inline-block;
        width: 100%;
        text-align: center;
        padding-bottom: 18px;
      }

      .box-card {
        border-radius: 24px;
        height: 193px;
        .notice {
          text-align: center;
          margin-top: -10px;
          padding-bottom: 5px;

          span {
            font-size: 10px;
            opacity: 0.6;
          }
        }

        .el-form {
          margin: 10px 8px 0 0;
          position: relative;

          .radio {
            display: flex;
            justify-content: center;
            margin: -8px 0 10px 0;
          }

          .forget {
            cursor: pointer;
            font-size: 8px;
            position: absolute;
            right: 20px;
            top: 100px;
          }
          .regNow {
            color: #409EFF;
            cursor: pointer;
            font-size: 8px;
            position: absolute;
            right: 25px;
            top: 115px;
          }
          .loginNow {
            color: #409EFF;
            cursor: pointer;
            font-size: 8px;
            position: absolute;
            right: 32px;
            top: 183px;
          }

          .button {
            display: flex;
            justify-content: center;
            margin: 0;
          }
        }
      }
    }

    //英文版样式
    .loginEn {
      position: fixed;
      z-index: 9;
      top: 30%;
      right: 10%;
      width: 500px;
      height: 285px;

      .title {
        font-size: 28px;
        //letter-spacing: 8px;
        color: #ffffff;
        display: inline-block;
        width: 100%;
        text-align: center;
        padding-bottom: 18px;
      }

      .box-card {
        border-radius: 24px;
        height: 215px;
        .notice {
          text-align: center;
          margin-top: -10px;
          padding-bottom: 5px;

          span {
            font-size: 10px;
            opacity: 0.6;
          }
        }

        .el-form {
          margin: 10px 8px 0 0;
          position: relative;

          .radio {
            display: flex;
            justify-content: center;
            margin: -8px 0 10px 0;
          }

          .forget {
            cursor: pointer;
            font-size: 8px;
            position: absolute;
            right: 20px;
            top: 100px;
          }
          .regNow {
            color: #409EFF;
            cursor: pointer;
            font-size: 8px;
            position: absolute;
            right: 25px;
            top: 115px;
          }
          .loginNow {
            color: #409EFF;
            cursor: pointer;
            font-size: 8px;
            position: absolute;
            right: 32px;
            top: 183px;
          }

          .button {
            display: flex;
            justify-content: center;
            margin: 0;
          }
        }
      }
    }
  }
</style>